import {
    Shirt, Gem, Plane, ShoppingBag, Utensils, Smartphone, Hotel, Tv,
    Watch, Dumbbell, HeartPulse, Sofa, Sparkles, Coins, Wrench,
    Apple, Crown, Wine, Baby, Footprints, Briefcase,
} from "lucide-react";

// Each category has a UNIQUE Lucide icon. Icons render in gold on navy or navy on ivory depending on variant.
const MAP = {
    "Apparel":                       Shirt,
    "Jewellery":                     Gem,
    "Digital Gold":                  Coins,
    "Travel":                        Plane,
    "Hotels":                        Hotel,
    "Online Shopping":               ShoppingBag,
    "Food & Beverage":               Utensils,
    "Groceries":                     Apple,
    "Electronics":                   Smartphone,
    "Entertainment & Subscriptions": Tv,
    "Watches":                       Watch,
    "Sports":                        Dumbbell,
    "Health & Wellness":             HeartPulse,
    "Home & Furniture":              Sofa,
    "Accessories":                   Footprints,
    "Services":                      Wrench,
    "Luxury":                        Crown,
    "Toys":                          Baby,
    "Other":                         Sparkles,
};

export default function CategoryIcon({ name, size = 24, className = "" }) {
    const Icon = MAP[name] || Briefcase;
    return <Icon size={size} strokeWidth={1.3} className={className} />;
}

export const CATEGORY_NAMES = Object.keys(MAP);
